import { IconName } from './enums';

export const DetailedIcons: IconName[] = [
  IconName.Chat,
  IconName.Crane,
  IconName.Dashboard,
  IconName.Documents,
  IconName.EditAddFile,
  IconName.GridMatrix,
  IconName.Handover,
  IconName.Replace,
  IconName.RulerPencil,
  IconName.SearchContent,
  IconName.Send,
  IconName.Tools,
];
